module.exports = __webpack_public_path__ + "static/media/img-13.891d7174.jpg";